import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListAIA extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}/aias/modal/${
              item.id
            }`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Status Date',
        dataIndex: 'updated_date'
      }
    ]
  }

  getData = () => {
    const { aias } = this.props

    const data = aias.map((aia, index) => {
      // format date from db
      aia.updated_date = moment(new Date(aia.updated_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${aia.id}${index}`,
          job: {
            job_id: aia.job_id,
            job_type: aia.job_type,
            number: aia.number,
            id: aia.id
          }
        },
        aia
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>AIAs</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListAIA



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListAIA.js